import { render, staticRenderFns } from "./bookinsight-themes.vue?vue&type=template&id=bec33936&"
import script from "./bookinsight-themes.vue?vue&type=script&lang=js&"
export * from "./bookinsight-themes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports